import React, { useState } from "react";
import InquiryModal from "../../components/InquiryModal";
import sriLankaImg from "../../assets/images/sri-lanka.jpg";

const SriLankaTour: React.FC = () => {
  const [showInquiry, setShowInquiry] = useState(false);

  return (
    <div
      style={{
        padding: "3rem 2rem",
        maxWidth: "900px",
        margin: "0 auto",
        fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
        color: "#333",
      }}
    >
      {/* Hero Section */}
      <div
        style={{
          backgroundImage: `url(${sriLankaImg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          borderRadius: "12px",
          padding: "5rem 2rem",
          color: "#fff",
          textAlign: "center",
          marginBottom: "2rem",
          boxShadow: "0 4px 15px rgba(0,0,0,0.2)",
        }}
      >
        <h1 style={{ fontSize: "3rem", fontWeight: 700 }}>Kandy & Colombo Tour</h1>
        <p style={{ fontSize: "1.25rem", marginTop: "1rem" }}>
          Explore ancient temples, lush hills, and beautiful beaches in Sri Lanka.
        </p>
      </div>

      {/* Highlights */}
      <div style={{ marginBottom: "2rem" }}>
        <h2 style={{ fontSize: "2rem", marginBottom: "1rem" }}>Highlights</h2>
        <ul style={{ paddingLeft: "1.2rem", lineHeight: 1.8 }}>
          <li>Temple of the Tooth, Kandy</li>
          <li>Colombo city tour</li>
          <li>Scenic train rides in hill country</li>
          <li>Relax at coastal beaches</li>
        </ul>
      </div>

      {/* Inquiry Button */}
      <div style={{ textAlign: "center", marginTop: "2rem" }}>
        <button
          onClick={() => setShowInquiry(true)}
          style={{
            padding: "0.8rem 2rem",
            backgroundColor: "#E1306C",
            color: "#fff",
            borderRadius: "6px",
            border: "none",
            fontWeight: "bold",
            cursor: "pointer",
            boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
            transition: "transform 0.3s",
          }}
          onMouseOver={(e) => (e.currentTarget.style.transform = "scale(1.05)")}
          onMouseOut={(e) => (e.currentTarget.style.transform = "scale(1)")}
        >
          Send Inquiry
        </button>
      </div>

      {/* Inquiry Modal */}
      {showInquiry && (
        <InquiryModal
          show={showInquiry}
          onClose={() => setShowInquiry(false)}
          inquiryData={{
            type: "Package",
            name: "",
            email: "",
            phone: "",
          }}
        />
      )}
    </div>
  );
};

export default SriLankaTour;
